import { fetchPosService } from "../fetchPosService";
import type {
  CartChangeRentalPlanMutation,
  CartChangeRentalPlanMutationVariables,
} from "../generates";
import { CartChangeRentalPlanDocument } from "../types";

export type ChangeCartRentalPlanProps = {
  itemId: number;
  store?: string;
  orderNumber: string;
  committedMonths: number;
};

export const changeCartRentalPlan = async ({
  itemId,
  store,
  orderNumber,
  committedMonths,
}: ChangeCartRentalPlanProps): Promise<CartChangeRentalPlanMutation> => {
  return fetchPosService<
    CartChangeRentalPlanMutation,
    CartChangeRentalPlanMutationVariables
  >({
    query: CartChangeRentalPlanDocument,
    variables: {
      input: {
        orderNumber,
        itemId,
        committedMonths,
      },
    },
    store,
  });
};
